import type { InteractionOverlaySettings } from '$/GraphQL/schema/schema';
import type { InteractionInfo, OverlayDimensions } from '$/components/Interactions/InteractionInfo';

export const useConversionNotificationCalcDimensions = (
  interaction: InteractionInfo,
  playerWidth: number,
  playerHeight: number,
  _settings?: InteractionOverlaySettings | null
): OverlayDimensions => {
  return {
    x: playerWidth / 2,
    y:
      interaction.displayLocation() === 'top'
        ? playerHeight * 0.02
        : playerHeight - playerHeight * 0.02,
    playerWidth,
    playerHeight,
    dynamicSize: true,
  };
};
